import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { get } from "@utils/axios_api";
import LectureTabNav from './LectureTabNav';
const LectureDetails = () => {
  const { lectureId } = useParams();
  const [lecture, setLecture] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const response = await get("/admin/lecture/lectureDetail", {
          params: { lectureId },
        });
        setLecture(response.lecture);
        setSchedule(response.schedule);
      } catch (err) {
        console.error(err);
        alert("상세 정보 조회에 실패했습니다.");
      }
    };
    fetchDetail();
  }, [lectureId]);

  const grouped = useMemo(() => {
    if (!Array.isArray(schedule) || schedule.length === 0) return {};
    return schedule.reduce((acc, row) => {
      (acc[row.eduDt] = acc[row.eduDt] || []).push(row);
      return acc;
    }, {});
  }, [schedule]);


  if (!lecture) return null;

  const handleUpdate = () => {
    navigate('/master/lectureForm', {state: {selectedLectureId: lectureId, isEdit: true}});
  }
  const handleBackList = () => {
    navigate("/master/lecture");
  };



  // 표 에 들어가는 가공 데이터
  const lectureNm = 
    lecture.catgRegYear && lecture.eduNo && lecture.lectureNm
      ? `[${lecture.catgRegYear}년 ${lecture.eduNo}차] ${lecture.lectureNm}` : "-";
  const period =
    lecture.applyStartDt && lecture.applyEndDt
      ? `${lecture.applyStartDt} ~ ${lecture.applyEndDt}`
      : "-";
  const lectureDate =
    lecture.firstDt && lecture.lastDt
      ? `${lecture.firstDt} ~ ${lecture.lastDt}`
      : lecture.firstDt || "-";
  const hoursText = lecture.eduHours ? `${lecture.eduHours} 시간` : "-";
  const feeText = lecture.eduPee ? `₩ ${lecture.eduPee.toLocaleString()}` : "-";
  const addressText = lecture.address1
    ? `${lecture.zipcode ? `(${lecture.zipcode}) ` : ""}${lecture.address1}${
        lecture.address2 ? ` ${lecture.address2}` : ""
      }`
    : "-";

  // 세부 일정 렌더 
  const renderSchedule = (date, list) => {
    // 현재 idx부터 같은 강사가 몇 행 이어지는지 계산
    const getSpan = (start) => {
      let span = 1;
      while (
        start + span < list.length &&
        list[start + span].combineInsNm === list[start].combineInsNm
      ) {
        span += 1;
      }
      return span;
    };
  
    return (
      <div key={date} style={{ marginTop: 16 }}>
        <h3 className="schedule-title">
          <span className="icon-squares" /> {date}
        </h3>
  
        <table className="table-write schedule-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "8%" }}>교시</th>
              <th>과목</th>
              <th style={{ width: "22%" }}>시간</th>
              <th style={{ width: "22%" }}>강사</th>
            </tr>
          </thead>
          <tbody>
            {list.map((c, idx) => {
              const isFirst =
                idx === 0 ||
                list[idx - 1].combineInsNm !== c.combineInsNm;
              const span = isFirst ? getSpan(idx) : 0; 
  
              return (
                <tr key={`${date}-${c.classNo}`}>
                  <td>{c.classNo}</td>
                  <td>{c.subject}</td>
                  <td>{`${c.startTm.slice(0, 2)}:${c.startTm.slice(2, 4)} ~ ${c.endTm.slice(0, 2)} : ${c.endTm.slice(2, 4)}`}</td>
                  {isFirst && <td rowSpan={span}>{c.combineInsNm}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };


  return (
    <div className="contents-wrap">
      <LectureTabNav lectureId={lectureId} active="detail" />
      {/* ---------- 제목 ---------- */}
      <div className="page-title-wrap">
      <h2 className="page-title"><span className="icon-gradient-square"></span>{lectureNm}</h2>
        <div className="section-tit-wrap" style={{marginRight:'7px'}}>
          <div className="btn-right-box">
            <ul>
            <li><button type="button" title="목록" className="btn-excel" onClick={handleBackList}>목록</button></li>
            <li><button type="button" title="수정" className="btn-save" onClick={handleUpdate}>수정</button></li>
            </ul>
          </div>
        </div>
      </div>

      {/* ---------- 상단 요약 ---------- */}
      <table className="table-write" style={{ width: "100%", textAlign:"center", fontSize:"1.0rem" }}>
        <colgroup>
          <col style={{ width: "14%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "12%" }} />
        </colgroup>
        <thead>
          <tr>
            <th>강의분류</th>
            <th>강의유형</th>
            <th>신청기간</th>
            <th>강의일자</th>
            <th>교육시간</th>
            <th>정원수</th>
            <th>수강료</th>
            <th>강의상태</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{lecture.eduCategoryNm}</td>
            <td>{lecture.eduTypeNm}</td>
            <td>{period}</td>
            <td>{lectureDate}</td>
            <td>{hoursText}</td>
            <td>{lecture.curStudentCnt}/{lecture.eduStdntLimit ?? ""}</td>
            <td>{feeText}</td>
            <td>{lecture.lectureStatusNm}</td>
          </tr>
        </tbody>
      </table>

      {/* ---------- 상세 항목 ---------- */}
      <table
        className="table-write"
        style={{ width: "100%", marginTop: 32 }}
      >
        <colgroup>
          <col style={{ width: "10%" }} />
          <col style={{ width: "40%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "40%" }} />
        </colgroup>
        <tbody>
          <tr>
            <th>관련법령</th>
            <td>{lecture.eduLaw ?? ""}</td>
            <th>강의목표</th>
            <td>{lecture.eduGoal ?? ""}</td>
          </tr>
          <tr>
            <th>출강사업장</th>
            <td >{lecture.companyNm ?? ""}</td>
            <th>교육장소</th>
            <td >{addressText}</td>
          </tr>
          <tr>
            <th>담당자</th>
            <td >{lecture.managerNm} ({lecture.managerEmail})</td>
            <th>담당자 전화번호</th>
            <td >{lecture.managerPhoneNo}</td>
          </tr>
          <tr>
          </tr>
          <tr>
            <th>강의내용</th>
            <td colSpan={3} style={{ whiteSpace: 'pre-line' }}>{lecture.eduContents ?? ""}</td>
          </tr>
        </tbody>
      </table>

      {/* ---------- 강의 세부 일정 ---------- */}
      {Object.keys(grouped).length ? (
        <>
          {Object.entries(grouped).map(([date, list]) =>
            renderSchedule(date, list),
          )}
        </>
      ) : null}
    </div>
  );
}

export {LectureDetails};